import { t } from '@lingui/core/macro';
import { isPhoneNumberValid } from 'noddi-util';
import { z } from 'zod';

// Customer review cannot confirm a profile that is missing either contact.
// The API allows one of them to be null; this screen does not.
export const getContactValidationSchema = () =>
  z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.email(t`Enter a valid email address`).min(1, t`Enter a valid email address`),
    phoneNumber: z
      .string()
      .min(1, t`Enter a valid phone number`)
      .refine((value) => isPhoneNumberValid(value), { message: t`Enter a valid phone number` })
  });
